"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invocation = exports.ErrorStrategy = void 0;
var source_1 = require("../job/source");
var callback_1 = require("../job/callback");
var ErrorStrategy;
(function (ErrorStrategy) {
    ErrorStrategy["STOP_ON_ERROR"] = "stopOnError";
    ErrorStrategy["CONTINUE_ON_ERROR"] = "continueOnError";
})(ErrorStrategy = exports.ErrorStrategy || (exports.ErrorStrategy = {}));
var Invocation = /** @class */ (function () {
    function Invocation(data) {
        this.sources = [];
        this.entryPoints = [];
        this.errorStrategy = ErrorStrategy.STOP_ON_ERROR;
        if (data) {
            this.sources = [];
            // tslint:disable-next-line
            for (var i in data.sources) {
                this.sources[i] = new source_1.Source(data.sources[i]);
            }
            if (data.callback) {
                this.callback = new callback_1.Callback(data.callback);
            }
            this.entryPoints = data.entryPoints;
            this.errorStrategy = data.errorStrategy;
        }
    }
    return Invocation;
}());
exports.Invocation = Invocation;
//# sourceMappingURL=invocation.js.map